/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Needed for redux-saga es6 generator support
import "core-js";
import "regenerator-runtime/runtime";

// Import all the third party stuff
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import FontFaceObserver from "fontfaceobserver";
import history from "utils/history";
import "sanitize.css/sanitize.css";

// Global Styles
import "scss/app.scss";

// Import root app
import App from "engine/App";

// Import Other Providers
import { AppProviders } from "engine/Contexts/AppProviders";

// Load the favicon, the .htaccess (Apache server) file and web.config (Windows server) 
import "!file-loader?name=[name].[ext]!./images/favicon.ico";
import "file-loader?name=.htaccess!./.htaccess"; // eslint-disable-line import/extensions
import "file-loader?name=[name].[ext]!./web.config"; // eslint-disable-line import/extensions

import configureStore from "./configureStore";
import {ErrorWrapper} from "./engine/Contexts/ErrorReportingBoundary";

// context
// import { ErrorWrapper } from './engine/Contexts/ErrorReportingBoundary/index.js';

// Observe loading of Open Sans (to remove open sans, remove the <link> tag in
// the index.html file and this observer)
const openSansObserver = new FontFaceObserver("Open Sans", {});

// When Open Sans is loaded, add a font-family using Open Sans to the body
openSansObserver.load().then(() => {
  document.body.classList.add("fontLoaded");
});

// Create redux store with history
const initialState = {};
export const store = configureStore(initialState, history);
const MOUNT_NODE = document.getElementById("app");

const render = () =>
  ReactDOM.render(
    <ErrorWrapper>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <AppProviders>
            <App />
          </AppProviders>
        </ConnectedRouter>
      </Provider>
    </ErrorWrapper>,
    MOUNT_NODE,
  );

render();

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept(["engine/App"], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render();
  });
}
